/**
 * @generated SignedSource<<768b5b3e895bcd92e254ac671c7716d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineLastRunJobFragment$data = {
  readonly buildType: {
    readonly name: string | null;
  } | null;
  readonly parallelized: boolean | null;
  readonly rawId: number | null;
  readonly status: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useBuildStatusIconFragment" | "useRunningBuildUpdaterRelayFragment">;
  readonly " $fragmentType": "PipelineLastRunJobFragment";
};
export type PipelineLastRunJobFragment$key = {
  readonly " $data"?: PipelineLastRunJobFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineLastRunJobFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineLastRunJobFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BuildTypeRest",
      "kind": "LinkedField",
      "name": "buildType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parallelized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuildStatusIconFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRunningBuildUpdaterRelayFragment"
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "40d71fe83f9c92b630f4c9c9d22af5d2";

export default node;
